export default __webpack_public_path__ + "static/media/icon-smoke.6d580e15.svg";